"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotionKeys = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var promotionKeys = (0, _keyMirror.default)({
  BRAZIL: null,
  HSFS_SEED: null,
  HSFS_SERIES_A: null,
  HSFX_ENTREPRENEUR: null,
  HSFX_BOOTSTRAP: null,
  LATAM_ES: null,
  NO_PROMOTION: null
});
exports.promotionKeys = promotionKeys;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/Promotions.js
// module id = 196
// module chunks = 5 6 7